import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import Quasar from 'quasar/src/vue-plugin.js';import Cookies from 'quasar/src/plugins/cookies/Cookies.js';;
import { createI18n } from 'vue-i18n';
import quasarUserOptions from './quasar-user-options';
import messages from './i18n';
import { createGtm } from '@gtm-support/vue-gtm';

const i18n = createI18n({
  locale: 'fr-FR',
  allowComposition: true,
  messages,
});

// 1 seule app déployée pour les 3 domaines inspire, dema1n, article-1 -> id GTM et script server-side choisis au runtime selon le hostname
const DEMA1N_GTM = { id: 'GTM-P7SM8JL', source: 'https://sst.dema1n.org/gpgx1qgg6fbrrel.js' };
const DEFAULT_GTM = { id: 'GTM-NHNLXJLF', source: 'https://sst.inspire-orientation.org/gpgx1qgg6fbrrel.js' };
const GTM_BY_HOSTNAME = {
  'connect.dema1n.org': DEMA1N_GTM,
  'connect-staging.dema1n.org': DEMA1N_GTM,
};
const gtm = GTM_BY_HOSTNAME[window.location.hostname] || DEFAULT_GTM;

createApp(App)
  .use(Quasar, quasarUserOptions)
  .use(router)
  .use(
    createGtm({
      id: gtm.id,
      queryParams: {
        // Add URL query string when loading gtm.js with GTM ID (required when using custom environments)
        //gtm_auth: 'jKX_yb-XL53EtB59zVIKmw',
        //gtm_preview: 'env-116',
        //gtm_cookies_win: 'x',
      },
      source: gtm.source, // Add your own serverside GTM script
      parentElement: document.head, // Le script est injecté dans le <head> (par défaut : <body>)
      defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
      compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
      nonce: 'okdfvlfdgfdg87897__', // Will add `nonce` to the script tag
      enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
      debug: true, // Whether or not display console logs debugs (optional)
      loadScript: false, // Le script GTM est chargé en inline dans public/index.html (sinon double chargement). Le plugin ne sert qu'aux helpers (trackEvent, router).
      ignoredViews: [], // Don't trigger events for specified router names (optional)
      trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
      vueRouter: router, // Pass the router instance to automatically sync with router (optional)
      vueRouterAdditionalEventData: () => ({
        visitorId: Cookies.get('visitorId'),
        category: 'SSO Article 1',
      }),
    }),
  )
  .use(createPinia())
  .use(i18n)
  .mount('#app');
